import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import Image from "./Image";
import { useTheme } from "../style/theme";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "12px",
  outline: "none",
};

const TrialEndModal = ({ open, onClose }) => {
  const {mode} = useTheme()
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle} className={`${mode == 'dark' ? 'bg-[#171717]' : 'bg-white'} w-[90vw] max-w-md shadow-lg`}>
        <div
          className="relative bg-no-repeat bg-center  rounded-t-[12px] flex items-center justify-center w-full h-full"
        // style={{
        //   backgroundImage: `url('/images/bgBlue.png')`,
        //   // backgroundSize:"cover",
        // }}
        >
          <div className="">
            <img src="/images/bgBlue.png" alt="" />
          </div>
          {/* <div className="bg-white rounded-full p-3 shadow-lg">
            <RocketLaunchIcon className="text-blue-600 text-3xl" />
          </div> */}
        </div>

        <div className="px-3 sm:px-6 text-center mt-3">
          <p className="font-semibold text-[12px] sm:text-[14px] mb-2">
            Oops! Your 14-day free trial is over
          </p>
          <p className={`${mode == 'dark' ? 'text-[#a5a5a5]' : 'text-gray-600'} mb-4 text-[10px] sm:text-[12px]`}>
            Your 14-day trial has ended, and you're now on the free starter
            plan. Upgrade to Enterprise for uninterrupted workflow and full
            features!
          </p>

          {/* <img src="/images/bgBlue.png" alt="" /> */}

          <Button
            fullWidth
            variant="contained"
            className="!bg-[#0080FF] hover:!bg-blue-500 text-white mb-2"
            sx={{fontSize:{md:"13px",xs:"10px"}}}
          >
            Upgrade to Enterprise Plan
          </Button>
          <Button
            fullWidth
            variant="text"
            onClick={onClose}
            className="text-sm text-[#0080FF]"
            sx={{fontSize:{md:"13px",xs:"10px"}}}
          >
            No, Continue with Free Starter Plan
          </Button>
        </div>

        <div className="text-[10px] sm:text-[12px] mt-2 pb-2 justify-center m-auto flex items-center w-full gap-1 font-semibold">
          <span>Powered By</span>
          <Image
            cdn="hr/logo/2023/hr.png"
            sx={{ height: "14px" }}
          // className={`${menuHover ? "opacity-25" : ""}`}
          // onClick={handleDrawerToggle}
          />
          <span>Clikkle HR</span>
        </div>
      </Box>
    </Modal>
  );
};

export default TrialEndModal;
